import React from "react";
import CourseSlider from "../components/Common/CourseSlider";
import Footer from "../components/Common/Footer";
import Header from "../components/Common/Header/Header";
import Album from "../components/Homepage/Album";
import AtGlance from "../components/Homepage/AtGlance";
import Block from "../components/Homepage/Block";
import SwiperSliderH from "../components/Homepage/SwiperSliderH";
import MessengerChat from "../components/MessengerChat/MessengerChat";
// import Reviews from "../components/Homepage/Reviews/Reviews";

const Homepage = () => {
  return (
    <>
      <div className="main-wrapper">
        <Header />
      </div>
      <div className="content-wrapper">
        <SwiperSliderH />
        <CourseSlider />
        <AtGlance />
        <Block />
        <Album />
        <MessengerChat />
        {/* <Reviews /> */}
      </div>
      <Footer />
    </>
  );
};

export default Homepage;